// libraries
import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

// styles
import styles from "./styles.module.scss";

// components
import Input from "./Input/Input";
import Button from "./Button/Button";
import Header from "./Header/Header";
import Divider from "./Divider/Divider";
import SocialIcon from "./SocialIcons/SocialIcon";
import Footer from "./Footer/Footer";

// utils
import { loginUser } from "src/utils/requests/register_screen/login";

// context
// import UserContext from "src/context/User";
import { UserAuthContext } from "src/context/UserAuthContext";

// animation
import FadeTop from "src/components/Animation/FadeTop";

const LoginForm = ({ changeForm }) => {
  const history = useHistory();
  // const { setUserData } = useContext(UserContext) || { setUser: null };
  const { saveUserData } = useContext(UserAuthContext);

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "" || password === "") {
      toast.info("Please filled out the required fields");
    } else {
      setLoading(true);

      loginUser(email, password)
        .then((res) => {
          if (res.data.Status) {
            saveUserData(res.data.Results);
            setLoading(false);
            history.push("/");
          } else {
            toast.error(res.data.ErrorMessage);
            setLoading(false);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  return (
    <form>
      <FadeTop duration={0.3}>
        <Header to="/" />
        <Input
          label="Email"
          placeholder="Write your email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          label="Password"
          placeholder="Use 8 character password"
          type="password"
          icon="true"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <p className={styles.forgot} onClick={() => changeForm(3)}>
          Forgot Password!
        </p>
        <Button label="Login" handleClick={handleSubmit} isLoading={loading} />
        <Divider />
        <SocialIcon setLoading={setLoading} setUserData={saveUserData} />
        <Footer
          label="Don't have an account?"
          btnLabel="create an account"
          fill
          text={`By clicking “Login” i agree to Event Moon Terms and Privacy. \n 
        i confirm that i am at least 13 years old.`}
          handleChange={() => changeForm(2)}
        />
      </FadeTop>
    </form>
  );
};

export default LoginForm;
